import { render, staticRenderFns } from "./RegisterIndex.vue?vue&type=template&id=e1636f78&"
import script from "./RegisterIndex.vue?vue&type=script&lang=js&"
export * from "./RegisterIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports